import { useState } from "react";

export default function WordCard({ word, hints, preview }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="word-card" onClick={() => setOpen(!open)}>
      <div className="word-card-header">
        <div>
          <div className="word-title">{word}</div>
          {preview && <div className="word-preview">{preview}</div>}
        </div>
        <div className="word-card-toggle">{open ? "-" : "+"}</div>
      </div>

      {open && (
        <div className="word-hints">
          {hints.map((hint, index) => (
            <div className="word-hint" key={`${hint.text}-${index}`}>
              <span>{hint.text}</span>
              <span>{Math.round(hint.weight * 100)}%</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
